module.exports = __webpack_public_path__ + "img/public/SiteIcons/wishlistOn.svg?ef339e1c";